import React, { Component } from "react";
import View from "./view";
import { getFormsForTool } from "../../../backend/machines";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class ToolHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tool_id: props.match.params.toolId,
      selectedTool: {
        value: props.tool.tool_id,
        label: props.tool.tool_code
      },
      forms: [],
      loading: false
    };
    this._renderForm = this._renderForm.bind(this);
  }

  render() {
    return View.call(this);
  }

  async componentDidUpdate(prevProps, prevState) {
    const { tool_id, code } = this.props.match.params;
    
    if (prevProps.match.params.tool_id !== tool_id) {
      this.setState({ loading: true });
      this.setState({
        forms: await getFormsForTool(tool_id),
        code: code,
        loading: false,
        // code : code
      });
    }
  }

  async componentDidMount() {
    const { tool_id } = this.props.match.params;
    this.setState({ loading: true });
    this.setState({
      forms: await getFormsForTool(tool_id),
      loading: false,
      // code : code
    });
  }

  _renderForm(inspection, key) {
    const { tool_id} = this.props.match.params;
    return (
      <div
        key={key}
        className={`machine ${inspection.status.replace(" ", "-")}`}
        onClick={this._navigate(
          `/tool-form/${tool_id}/${inspection.id}/`
        )}
      >
        <div className="id">{inspection.code}</div>
        <div className="status">{inspection.status}</div>
        <div className="created-at">{inspection.created_at}</div>
      </div>
    );
  }

  _navigate(location) {
    const { history } = this.props;
    return event => {
      history.push(location);
    };
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    tool: state.selections.tool || { tool_code: "", tool_id: "" }
  };
};

export default withRouter(connect(mapStateToProps)(ToolHistory));



// WEBPACK FOOTER //
// ./src/screens/machines/tool-history/index.js